import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * useDocumentMeta — Sets document.title, <html lang>, and meta description
 * on language change.
 */
const useDocumentMeta = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t('app.title');
    document.documentElement.lang = i18n.language.substring(0, 2);

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', t('app.description'));
    }
  }, [t, i18n.language]);
};

export default useDocumentMeta;
